import router from '@/router';

export default function logout() {
	localStorage.removeItem('redirected');
	window.sessionStorage.clear();
	router.push('/login');
}